/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartElement = document.querySelector('ajax-cart');

        this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
        this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }

    /**
     * Product Form Submit event
     *
     * @param {evt} Event instance
     */
    onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        const qtyInput = this.querySelector('[data-qty-input]');

        const selectOption = this.querySelector('[data-select-option]');
        const selectedQty = selectOption.value;
        const availableQty = selectOption.getAttribute('data-variant-qty');
        const inventoryManagement = selectOption.getAttribute('data-inventory-management');

        if (parseInt(availableQty) >= parseInt(selectedQty) || inventoryManagement == 'null' || inventoryManagement == null) {
            submitButton.setAttribute('disabled', true);
            submitButton.classList.add('loading');

            const body = JSON.stringify({
                ...JSON.parse(serializeForm(this.form))
            });

            fetch(`${routes.cart_add_url}`, {...fetchConfig('javascript'), body })
                .then((response) => response.json())
                .then((parsedState) => {
                    if (document.querySelector('#PopupModal-quickshop')) {
                        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
                    }
                    this.cartElement.getCartData('open_drawer');
                    if (qtyInput) qtyInput.value = 1;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('disabled');
                    if (this.querySelector('#variant-qty-error').classList.contains('d-block')) {
                        this.querySelector('#variant-qty-error').classList.remove("d-block");
                    }
                    this.querySelector('#variant-qty-error').classList.add('d-none');
                });
        } else {
            // alert('Only ' + availableQty + ' items available for purchase. Modify current value.');
            if (this.querySelector('#variant-qty-error').classList.contains('d-none')) {
                this.querySelector('#variant-qty-error').classList.remove("d-none");
            }
            this.querySelector('#variant-qty-error').classList.add('d-block');
            const variantQtyError = this.querySelector('#variant-qty-error');
            variantQtyError.innerHTML = '<span class="text-danger fw-medium ls-xs">Only ' + availableQty + ' items available for purchase. Modify current value.</span>';
        }

    }

    /**
     * Product Form Quantity Input update action
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let action = currentTarget.dataset.for || 'increase';
        let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
        let currentQty = parseInt($qtyInput.value) || 1;
        let finalQty = 1;

        if (action == 'decrease' && currentQty <= 1) {
            return false;
        } else if (action == 'decrease') {
            finalQty = currentQty - 1;
        } else {
            finalQty = currentQty + 1;
        }

        $qtyInput.value = finalQty;
    }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('form');
        this.formType = this.form.dataset.format;
        this.addBtn = this.form.querySelector('[name="add"]');
        this.variant_json = this.form.querySelector('[data-variantJSON]');
        this.variantPicker = this.dataset.type;

        if (this.formType == 'product-page') this.onVariantChange();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.setCurrentVariant();
        const currentVariantTitle = this.currentVariant.title;
        // console.log("currentVariantTitle==", this.currentVariant);

        if (window.globalVariables.template == "product") {
            this.variantQuantityJSON = this.form.querySelector('[data-variantQuantityJSON]').innerHTML;
            const jsonVARIANT = JSON.parse(this.variantQuantityJSON);
            for (var i = 0; i < jsonVARIANT.length; i++) {
                var variantID = jsonVARIANT[i];
                if (this.currentVariant.id == variantID.variants_id) {
                    document.querySelector("[data-variant-qty]").setAttribute("data-variant-qty", variantID.variant_inventory);
                    if (this.currentVariant.inventory_management != null) {
                        document.querySelector("[data-inventory-management]").setAttribute("data-inventory-management", this.currentVariant.inventory_management);
                    }
                }
            }

            if (document.querySelector('#variant-qty-error').classList.contains('d-block')) {
                document.querySelector('#variant-qty-error').classList.remove("d-block");
            }
            document.querySelector('#variant-qty-error').classList.add('d-none');

            document.querySelectorAll("[data-set-title]")[0].innerHTML = currentVariantTitle.split(' / ')[0];
          
            if (currentVariantTitle.indexOf('/') > -1) {
                document.querySelectorAll("[data-set-title]")[1].innerHTML = currentVariantTitle.split(' / ')[1];
                if (document.querySelectorAll("[data-set-title]")[2] != null) {
                    document.querySelectorAll("[data-set-title]")[2].innerHTML = currentVariantTitle.split(' / ')[2];
                }
            }
        }

        if (!this.currentVariant) {
            this.toggleAddButton('disable');
        } else {
            if (this.formType == 'grid') {
                const productGrid = this.closest('[data-product-grid]');
                this.renderProductInfo(this.currentVariant, productGrid);
                this._updateLinks(productGrid);
            } else {
                const productPage = this.closest('[data-product-container]');
                this.renderProductInfo(this.currentVariant, productPage);
            }
            this.updateURLandID(this.currentVariant);
            this.toggleAddButton('enable');
        }
    }

    _updateLinks(productGrid) {
        if (!this.currentVariant || !productGrid) return;
        const variantURL = '?variant=' + this.currentVariant.id;
        const formLinks = productGrid.querySelectorAll('.product-link');
        formLinks.forEach(link => {
            let href = link.href.split('?')[0];
            link.href = href + variantURL;
        });
    }

    _getOptionsFromSelect() {
        let options = [];
        this.querySelectorAll('.variant_selector').forEach((selector) => {
            options.push(selector.value);
        });
        return options;
    }

    _getOptionsFromRadio() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        const options = fieldsets.map((fieldset) => {
            // if (fieldset.querySelector('[color-custom-dropdown]')) {
            //     return Array.from(fieldset.querySelector('[color-custom-dropdown]')).find((option) => option.selected).value;
            // } else {
            //     return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
            // }
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
        return options;
    }

    setCurrentVariant() {
        // get all current values from selectors
        this.currentVariant = false;
        let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

        let variantsArray = this._getVariantData();
        variantsArray.find((variant) => {
            // get true or false based on options value presented in variant
            // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
            let mappedValues = variant.options.map((option, index) => {
                return options[index] === option;
            });

            // assign variant details to this.currentVariant if all options are present
            if (!mappedValues.includes(false)) {
                this.currentVariant = variant;
                return;
            }
        });
    }

    updateURLandID(currentVariant) {
        if (!currentVariant) return;

        // update query string with latest variant ID
        if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

        // update variant input with currentVariant Id
        const input = this.form.querySelector('input[name="id"]');
        input.value = currentVariant.id;
    }

    renderProductInfo(currentVariant, container) {

        if (window.globalVariables.template == "product" && currentVariant != false) {
            // console.log("currentVariant==>11111", currentVariant);
            this.productLifeStyleImage(currentVariant);
        }

        if (!currentVariant || !container) return;

        // Price Update
        let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
        let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
        let priceElement = container.querySelector('[data-currentPrice]');
        let comparePriceElement = container.querySelector('[data-comparePrice]');

        if (priceElement) priceElement.innerHTML = price;
        if (comparePriceElement) comparePriceElement.innerHTML = compare_price;

        // Grid Image Update on variant selection
        if (this.formType == 'grid') {
            if (!currentVariant.featured_image) return;
            const featuredImage = container.querySelector('[data-feauredImage]');
            const hoverImage = container.querySelector('[data-hoverImage]');
            let updatedSrc = currentVariant.featured_image.src;
            if (updatedSrc) {
                featuredImage.src = updatedSrc;
                featuredImage.srcset = updatedSrc;
                hoverImage.src = updatedSrc;
                hoverImage.srcset = updatedSrc;
            }
        } else {
            if (!currentVariant.featured_image) return;
            let imageID = currentVariant.featured_image.id;
            let imageSlide = document.querySelector(`.product--image[data-imageID="${imageID}"]`);
            if (this.formType == 'quickshop') {
                imageSlide = document.querySelector(`.quickshop-slider .product--image[data-imageID="${imageID}"]`);
            }
            if (!imageSlide) return;
            let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
            if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
            else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
        }

        // Variant name update
        let options = this.form.querySelectorAll('[data-optionindex]');
        options.forEach(option => {
            let lableID = 'option' + option.dataset.optionindex;
            const lable = option.querySelector('.selected-option');
            if (!lable || !lableID) return;
            lable.innerHTML = currentVariant[lableID];
        });
    }

    productLifeStyleImage(productLifeStyleImage) {

        this.productJsonData = this.form.querySelector('[data-productData]');
        this.productJsonData = JSON.parse(this.productJsonData.textContent);

        let currentVariantSlidesHTML = '';
        let currentVariantThumbsHTML = '';
        let beforeVariantSlidesHTML = '';
        let beforeVariantThumbsHTML = '';

        if (productLifeStyleImage.featured_image) {
            var currentVariantImage = productLifeStyleImage.featured_image.src;
        } else {
            var currentVariantImage = null;
        }
        let currentVariantImageFlag = false;

        if (productLifeStyleImage == null) { return false; }

        this.productJsonData.media.forEach(function(i, v) {
            if( currentVariantImage == i.preview_image.src || currentVariantImageFlag == true) {
                currentVariantSlidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                <img src="${i.preview_image.src}" alt="${i.alt}"/>
                            </div>`;
                currentVariantThumbsHTML += `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                    <img class="img-fluid" src="${i.preview_image.src}" alt="${i.alt}" />
                                </div>`;
                currentVariantImageFlag = true;
            } 
            else {
                beforeVariantSlidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                    <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                    <img src="${i.preview_image.src}" alt="${i.alt}"/>
                                </div>`;
                beforeVariantThumbsHTML += `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                        <img class="img-fluid" src="${i.preview_image.src}" alt="${i.alt}" />
                                    </div>`;
            }
        });

        let finalnavHTML = `<div class="swiper swiper-slider product-thumbnails" data-slider='{
                                "direction":"horizontal",
                                "loop": false,
                                "slidesPerView": "5",
                                "spaceBetween": 2,
                                "slideToClickedSlide": true,
                                "observer": true,
                                "observeParents": true,
                                "breakpoints": {
                                    "768": {
                                        "direction":"horizontal",
                                        "slidesPerView": "10",
                                        "spaceBetween": 2
                                    }
                                }
                            }' role="tree">
                            <div class="swiper-wrapper">
                                ${currentVariantThumbsHTML}
                                ${beforeVariantThumbsHTML}
                            </div>
                        </div>`;

        let finalHTML = `<slider-element class="swiper-container">
                          <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails" data-slider='{
                                "loop": false,
                                "slidesPerView": "1",
                                "spaceBetween": 15,
                                "observer": true,
                                "observeParents": true,
                                "navigation": {
                                    "nextEl": ".swiper-button-next",
                                    "prevEl": ".swiper-button-prev"
                                },
                                "pagination": {
                                    "el": ".swiper-pagination"
                                }
                            }' role="tree">
                            <div class="swiper-wrapper">
                                ${currentVariantSlidesHTML}
                                ${beforeVariantSlidesHTML}
                            </div>
                            <div class="swiper-button-next icon-arrow-right"></div>
                            <div class="swiper-button-prev icon-arrow-left"></div>
                        </div>    
                      </slider-element>`;

        const thumbParent = document.querySelector('[data-thumbSlider]');
      if(thumbParent != null){
        thumbParent.innerHTML = finalnavHTML;
      }

        const sliderParent = document.querySelector('[data-main-slider]');
        sliderParent.innerHTML = finalHTML;
     
    }

    productLifeStyleImage_with_alt(productLifeStyleImage) {

        this.productJsonData = this.form.querySelector('[data-productData]');
        this.productJsonData = JSON.parse(this.productJsonData.textContent);

        let thumbnailsALLHTML = '';
        let thumbnailsHTML = '';
        let slidesALLHTML = '';
        let slidesHTML = '';
        let flag = false;

        let mediaAlt = '';
        let mediaAlt2 = '';
        let mediaAlt3 = '';

        let addedHTMLMain = '';
        let addedHTMLSub = '';

        if (productLifeStyleImage == null) { return false; }

        let altText = productLifeStyleImage.title.toLowerCase();
        let altArray = altText.split(" / ");

        this.productJsonData.media.forEach(function(i, v) {

            // If we found any images for variant ( HTML )
            if (i.alt != null) {
                let mediaAltArray = i.alt.split("||");
                let length = mediaAltArray.length;
                if (length > 1) {
                    if (mediaAltArray[1] != null) { mediaAlt = mediaAltArray[1].toLowerCase().trim(); }
                    if (mediaAltArray[2] != null) { mediaAlt2 = mediaAltArray[2].toLowerCase().trim(); }
                    if (mediaAltArray[3] != null) { mediaAlt3 = mediaAltArray[3].toLowerCase().trim(); }

                    // if alt is null or blank & checking the image alt text on the variant title (indexOf)
                    if (altText.indexOf(mediaAlt) > -1 || altText.indexOf(mediaAlt2) > -1 || altText.indexOf(mediaAlt3) > -1) {
                        if (mediaAlt == altArray[0] || mediaAlt == altArray[1] || mediaAlt == altArray[2] ||
                            mediaAlt2 == altArray[0] || mediaAlt2 == altArray[1] || mediaAlt2 == altArray[2] ||
                            mediaAlt3 == altArray[0] || mediaAlt3 == altArray[1] || mediaAlt3 == altArray[2]) {

                            // Found match color option
                            flag = true;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                                <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                                <img src="${i.preview_image.src}" alt="${i.alt}" />
                                            </div>`;
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                                <img class="img-fluid" src="${i.preview_image.src}" alt="${i.alt}" />
                                            </div>`;
                        }
                    }
                }
            }

            // If we dont found any images for variant ( HTML )
            slidesALLHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                                <img src="${i.preview_image.src}" alt="${i.alt}"/>
                            </div>`;
            thumbnailsALLHTML += `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                    <img class="img-fluid" src="${i.preview_image.src}" alt="${i.alt}" />
                                </div>`;
        });

        // If we dont found any images then replace all images on slider
        if (flag == true) {
            addedHTMLMain = slidesHTML;
            addedHTMLSub = thumbnailsHTML;
        } else {
            addedHTMLMain = slidesALLHTML;
            addedHTMLSub = thumbnailsALLHTML;
        }

        let finalnavHTML = `<div class="swiper swiper-slider product-thumbnails" data-slider='{
                                "direction":"horizontal",
                                "loop": false,
                                "slidesPerView": "5",
                                "spaceBetween": 2,
                                "centeredSlides": true,
                                "slideToClickedSlide": true,
                                "observer": true,
                                "observeParents": true,
                                "breakpoints": {
                                    "768": {
                                        "direction":"horizontal",
                                        "slidesPerView": "10",
                                        "spaceBetween": 2
                                    }
                                }
                            }' role="tree">
                            <div class="swiper-wrapper">
                                ${addedHTMLSub}
                            </div>
                        </div>`;

        let finalHTML = `<slider-element class="swiper-container">
                          <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails" data-slider='{
                                "loop": false,
                                "slidesPerView": "1",
                                "spaceBetween": 15,
                                "centeredSlides": true,
                                "observer": true,
                                "observeParents": true,
                                "navigation": {
                                    "nextEl": ".swiper-button-next",
                                    "prevEl": ".swiper-button-prev"
                                },
                                "pagination": {
                                    "el": ".swiper-pagination"
                                }
                            }' role="tree">
                            <div class="swiper-wrapper">
                                ${addedHTMLMain}
                            </div>
                            <div class="swiper-button-next icon-arrow-right"></div>
                            <div class="swiper-button-prev icon-arrow-left"></div>
                        </div>    
                      </slider-element>`;

        const thumbParent = document.querySelector('[data-thumbSlider]');
        thumbParent.innerHTML = finalnavHTML;

        const sliderParent = document.querySelector('[data-main-slider]');
        sliderParent.innerHTML = finalHTML;
    }

    productLifeStyleImage_Old(productLifeStyleImage) {

        this.productJsonData = this.form.querySelector('[data-productData]');
        this.productJsonData = JSON.parse(this.productJsonData.textContent);
        // console.log("cproductJsonData==>11111", this.productJsonData);

        let thumbnailsALLHTML = '';
        let thumbnailsHTML = '';
        let currentVariantHTML = '';
        let flagMixImage = false;
        let flag = false;

        let mediaAlt = '';
        let mediaAlt2 = '';
        let mediaAlt3 = '';

        if (productLifeStyleImage.featured_image) {
            var currentVariantImage = productLifeStyleImage.featured_image.src;
        } else {
            var currentVariantImage = null;
        }
        let currentVariantImageFlag = false;

        let addedHTMLSub = '';

        if (productLifeStyleImage == null) {
            return false;
        }

        let altText = productLifeStyleImage.title.toLowerCase();
        let altArray = altText.split(" / ");
        // console.log('currentVariantImage=============', currentVariantImage)

        this.productJsonData.media.forEach(function(i, v) {
            // If we dont found Variant images for variant ( HTML )
            if (currentVariantImage != null && currentVariantImageFlag != true) {
                currentVariantImageFlag = true;
                currentVariantHTML += `<div class="swiper-slide" data-imageID="" role="treeitem">
                                <img class="img-fluid"
                                src="${currentVariantImage}"
                                data-src="${currentVariantImage}"
                                alt="" />
                                <div class="zoom-icon" onclick="openImage(this)">
                                <img src="https://cdn.shopify.com/s/files/1/0599/9863/4165/files/zoom-in-line.svg?v=1640172497" alt="zoom-icon" />
                                </div>
                            </div>`;
                // flag = true;
            }

            // If we found any images for variant ( HTML )
            if (i.alt != null) {
                let mediaAltArray = i.alt.split("||");
                let length = mediaAltArray.length;
                if (length > 1) {
                    if (mediaAltArray[1] != null) { mediaAlt = mediaAltArray[1].toLowerCase().trim(); }
                    if (mediaAltArray[2] != null) { mediaAlt2 = mediaAltArray[2].toLowerCase().trim(); }
                    if (mediaAltArray[3] != null) { mediaAlt3 = mediaAltArray[3].toLowerCase().trim(); }

                    // if alt is null or blank & checking the image alt text on the variant title (indexOf)
                    if (altText.indexOf(mediaAlt) > -1 || altText.indexOf(mediaAlt2) > -1 || altText.indexOf(mediaAlt3) > -1) {
                        if (mediaAlt == altArray[0] || mediaAlt == altArray[1] || mediaAlt == altArray[2] ||
                            mediaAlt2 == altArray[0] || mediaAlt2 == altArray[1] || mediaAlt2 == altArray[2] ||
                            mediaAlt3 == altArray[0] || mediaAlt3 == altArray[1] || mediaAlt3 == altArray[2]) {

                            // Found match color option
                            if (currentVariantImage != i.preview_image.src || currentVariantImage == null) {
                                thumbnailsHTML += `<div class="swiper-slide" data-imageID="${i.id}" role="treeitem">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                data-src="${i.preview_image.src}"
                                                alt="${i.alt}" />
                                                <div class="zoom-icon" onclick="openImage(this)">
                                                <img src="https://cdn.shopify.com/s/files/1/0599/9863/4165/files/zoom-in-line.svg?v=1640172497" alt="zoom-icon" />
                                                </div>
                                            </div>`;
                                flag = true;
                            }
                        } else {
                            if (currentVariantImage != i.preview_image.src || currentVariantImage == null) {
                                flagMixImage = true;
                            }
                        }
                    }
                }
            }

            if (flagMixImage != true) {
                // If we dont found any images for variant ( HTML )
                if (currentVariantImage != i.preview_image.src || currentVariantImage == null) {
                    thumbnailsALLHTML += `<div class="swiper-slide" data-imageID="${i.id}" role="treeitem">
                                            <img class="img-fluid"
                                            src="${i.preview_image.src}"
                                            data-src="${i.preview_image.src}"
                                            alt="${i.alt}" />
                                            <div class="zoom-icon" onclick="openImage(this)">
                                            <img src="https://cdn.shopify.com/s/files/1/0599/9863/4165/files/zoom-in-line.svg?v=1640172497" alt="zoom-icon" />
                                            </div>
                                        </div>`;
                }
            }
            if (currentVariantImage != i.preview_image.src || currentVariantImage == null) {
                flagMixImage = false;
            }

        });

        // If we dont found any images then replace all images on slider
        if (flag == true) {
            addedHTMLSub = thumbnailsHTML;
        } else {
            addedHTMLSub = thumbnailsALLHTML;
            console.log('The name of the Variable option does not match the Image alt');
        }
        let finalHTML = `<div class="swiper product-slider">
                            <div class="swiper-wrapper">
                                ${currentVariantHTML}
                                ${addedHTMLSub}
                            </div>
                        </div>`;

        const sliderParent = document.querySelector('[data-main-slider]');
        sliderParent.innerHTML = finalHTML;
    }

    toggleAddButton(status) {
        if (!this.addBtn) return;

        if (status == 'disable') {
            this.addBtn.setAttribute('disabled', true);
            if (this.addBtn.querySelector('.add-text'))
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
        } else if (this.currentVariant && !this.currentVariant.available) {
            this.addBtn.setAttribute('disabled', true);
            if (this.addBtn.querySelector('.add-text'))
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
        } else {
            this.addBtn.removeAttribute('disabled');
            if (this.addBtn.querySelector('.add-text'))
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;;
        };
    }

    _getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();

        this.form = this.closest('form');
        this.formType = this.form.dataset.format;

        const colorSwatchContainer = this.querySelector('.color-swatch');
        if (colorSwatchContainer) {
            const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
            colorSwatches.forEach(swatch => {
                let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
                let swatchImg = swatch.querySelector('input[type="radio"]').dataset.swatchimg;
                let swatchHexcode = swatch.querySelector('input[type="radio"]').dataset.hexcode;
                let swatchShade = swatch.querySelector('input[type="radio"]').dataset.shade;

                if (swatchImg != '') {
                    swatch.querySelector('.swatch-label').setAttribute('style', 'background-image: url(' + swatchImg + ')');
                } else if (swatchHexcode != '') {
                    swatch.querySelector('.swatch-label').setAttribute('style', 'background-image: linear-gradient(to right,' + swatchHexcode + ')');
                } else if (swatchShade != '') {
                    swatch.querySelector('.swatch-label').setAttribute('style', 'background-image: linear-gradient(to right,' + swatchShade + ')');
                } else {
                    let swatchStyle = Utility.getSwatchStyle(colorHandle);
                    swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
                }

                // let swatchStyle = Utility.getSwatchStyle(colorHandle);
                // swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
            });
        }
    }
}
customElements.define('variant-radios', VariantRadios);


function addRelatedProduct(currentTarget) {
    let relatedProductVariantId = currentTarget.getAttribute("data-relatedProductVariantId") || null;

    currentTarget.closest('[grid-related-product]').style.pointerEvents = "none";
    currentTarget.closest('[grid-related-product]').style.opacity = "0.6";

    const result = fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: relatedProductVariantId,
            quantity: 1
        })
    }).then(response => {
        document.querySelector('ajax-cart').getCartData('open_drawer');
        currentTarget.closest('[grid-related-product]').style.pointerEvents = "visible";
        currentTarget.closest('[grid-related-product]').style.opacity = "1";
    })
}

function openImage(currentTarget) {

    let productSrc = currentTarget.closest('.swiper-slide').querySelector('[data-src]').getAttribute('data-src');

    const productImageModal = document.getElementById('PopupModal-productImage');
    const modal = productImageModal.querySelector('.modal');
    modal.classList.add('open');

    const productImageSection = productImageModal.querySelector('.productImage-section');
    productImageSection.innerHTML += '<img class="img-fluid" src="' + productSrc + '" alt="image"  />';
    document.body.style.overflowY = "hidden";
}